import { Navigate } from "react-router-dom";

export default function SubDetailBindPage() {
  return <Navigate to="/forex/sub-accounts" replace />;
}
